<ng-container>
  <button
    aria-label="Koszyk"
    (click)="goToCart()"
    type="button"
    class="clear-button icon-button">
    <app-icon name="shopping_cart" color="#575481"></app-icon>
    <div *ngIf="counter > 0" class="badge">{{ counter }}</div>
  </button>
</ng-container>

